module.exports = __webpack_public_path__ + "assets/img/btn-back-a82e0c13.png";